const getStop = (length) => {
    if (length === 1) {
        return "Non-stop"
    }
    else {
        return `${length - 1} stops`
    }
}

export default getStop;